import { useTranslation } from "react-i18next";

const Footer = ({ style }) => {
    const { t } = useTranslation();

    let startWidth = window.innerWidth;
    const handleResize = () => { 
        if(startWidth-50>window.innerWidth||startWidth+50<window.innerWidth){ 
            window.location.reload();
        }
    };
    
    window.addEventListener('resize', handleResize);
   
    return (
        <section className="footer" style={style}>
            {/* Remove underlines from all links in footer */}
            <style>{`
                .footer a {
                    text-decoration: none !important;
                }
                .footer a:hover {
                    text-decoration: none !important;
                }
                .footer a:focus {
                    text-decoration: none !important;
                }
                .footer a:active {
                    text-decoration: none !important;
                }
                .footer a:visited {
                    text-decoration: none !important;
                }
            `}</style>
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 logo col-md-4 col-12">
                        <a href="#"><img src={require('../assets/img/logo-footer.png')} alt="Logo" /></a>
                    </div>
                    <div className="col-lg-4 col-md-4 col-12">
                        <h3>{t("contact_us")}</h3>
                        <p>
                            <a href="tel:383049253035">+383 (0) 49 25 30 35</a><br/>
                            <a href="mailto:info@fluturolire.com">info@fluturolire.com</a>
                        </p>
                    </div>
                    <div className="col-lg-4 col-md-4 col-12">
                        <h3>{t("connect_with_us")}</h3>
                        <a className="mr-2" target='_blank' rel="noopener noreferrer" href="https://www.facebook.com/Fluturolirecom">
                            <img src={require('../assets/img/icon-facebook.png')} alt="Facebook" />
                        </a>
                        <a target='_blank' rel="noopener noreferrer" href="https://www.instagram.com/fluturolirecom">
                            <img src={require('../assets/img/icon-instagram.png')} alt="Instagram" />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Footer;